module.exports = __webpack_public_path__ + "img/logo1.a897e6a5.png";